import { getLogger } from "@expert/logging";
import { Flex } from "@mantine/core";
import { withErrorBoundary } from "react-error-boundary";
import { CallControlsManager } from "@/call-controls";
import type { VoiceTask } from "@/sdk";
import { createFallbackRender } from "@/shared-utils";

const logger = getLogger({ module: "Workspace" });

const CallControlsManagerHandled = withErrorBoundary(CallControlsManager, {
    fallbackRender: createFallbackRender(logger),
});

interface WorkspaceContentTopbarSlotProps {
    activeVoiceTask: VoiceTask | null;
}

export function WorkspaceContentTopbarSlot({ activeVoiceTask }: WorkspaceContentTopbarSlotProps) {
    return (
        <Flex pos={"absolute"} inset={0} justify={"center"} align={"center"} p={"sm"}>
            <CallControlsManagerHandled voiceTask={activeVoiceTask} />
        </Flex>
    );
}
